import { useFormikContext } from "formik";
import React from "react";
import { amountPrecision } from "constants/formConstants";

import { Form, Label } from "semantic-ui-react";
// import PaidCheckBox from "../PaidCheckBox";

function AmountAndPaidInput({ currency = "Rs.", ...rest }) {
	const { values } = useFormikContext();
	return (
		<Form.Input
			{...rest}
			fluid
			labelPosition="left"
			value={((values.quantity ?? 0) * (values.rate ?? 0)).toFixed(
				amountPrecision
			)}
			label="Amount"
		>
			<Label>{currency}</Label>
			<input />
			{/* <PaidCheckBox
				content="Paid?"
				icon={values.paid ? "check" : "x"}
				{...(values.paid ? { color: "teal" } : {})}
			/> */}
		</Form.Input>
	);
}

export default AmountAndPaidInput;
